
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { IHeaderParams } from 'ag-grid-community';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { IPhoneFilterListPhoneCustomer } from '../../../../../api/customer/customerApi';
import { ICustomerTypes } from '../../../../../api/selectOption/selectOptionsApi';
import { ICodeCustomer, IProvince, IUnitOption, IprovinceChild } from '../../../../../api/selectOptions/selectOptionsApi';
import useDebounce from '../../../../../hook/useDebounce';
import useThrottle from '../../../../../hook/useThrottle';
import { dataTypeCustomer } from '../../../../../services/data';
import { selectorInfoUser } from '../../../../../store/slices/infoUserSlice';
import { fommatdataType } from '../../../../../until';
import { IDataDefaulFilterList } from '../../../../CustomersV2/indexV2';
import ModalFilter from './ModalFilter';
import { FilterIcon } from '../../../../CustomersV2/Modal/FilterIcon';
interface FilterHeaderProps extends IHeaderParams {
  dataFilterList: IDataDefaulFilterList
  fieldLabel?: string;

  setDataFilterList: (dataFilterList: IDataDefaulFilterList) => void,
}

const FilterHeader: React.FC<FilterHeaderProps> = (props) => {
  const { unitTemp } = useSelector(selectorInfoUser) // đợn vị dc chọn

  const {
    displayName, column, api, dataFilterList,
    setDataFilterList

  } = props;
  const columnId = column.getColId()
  const hiddenFilterIcon = new Set(
    [
      "brand", "unit", "staff"
    ]);
  const isHiddenFilterIcon = hiddenFilterIcon.has(columnId)

  const [activeSort, setActiveSort] = useState<null | 'asc' | 'desc'>(null);

  const [openModal, setOpenModal] = useState(false)
  const [openModalTypeCustomer, setOpenModalTypeCustomer] = useState(false)
  const [openModalProvinceChild, setOpenModalProvinceChild] = useState(false)
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [checkShowSearch, setCheckShowSearch] = useState(false);

  const [checkedValues, setCheckedValues] = useState<(string | number)[]>([]);

  const [sLCustomerType, setSLCustomerType] = useState<ICustomerTypes[]>([])
  const [sLProvince, setSLProvince] = useState<IProvince[]>([])
  const [sLCodeCustomer, setSLCodeCustomer] = useState<ICodeCustomer[]>([])
  const [sLProviChild, setSLProviChild] = useState<IprovinceChild[]>([])
  const [sLUnit, setSLUnit] = useState<IUnitOption[]>([])
  const [sLPhone, setSLPhone] = useState<IPhoneFilterListPhoneCustomer[]>([])

  const prevSearchRef = useRef<string | undefined>(undefined);
  const [search, setSearch] = useState<string>()

  const toNumberArray = (arr: (string | number)[]) => {
    return arr.map(Number).filter(Number.isFinite) as number[]
  }

  const toStringArray = (arr: (string | number)[]) => arr.map(String);

  const gSLFilterData = () => {
    if (openModal) {
      switch (columnId) {

        default:
          return fommatdataType(dataTypeCustomer);
      }

    } else {
      return []
    }
  }

  const isColumnFiltered = useMemo(() => {
    switch (columnId) {
      // case "bussinessCheck": return !!dataFilterList.businessCheck?.length;
      // case "unitName": return !!dataFilterList.listUnit?.length;
      // case "gender": return !!dataFilterList.gender?.length;
      // case "province": return !!dataFilterList.listArea?.length;
      // case "district": return !!dataFilterList.listDistrict?.length;
      // case "customerCode": return !!dataFilterList.listCode?.length;
      // case "phone": return !!dataFilterList.listPhone?.length;
      // case "customerType": return !!dataFilterList.listType?.length;
      // case "birthdayOrFoundingDate":
      //   return !!(dataFilterList.dateStart);
      default: return false;
    }
  }, [columnId, dataFilterList]);

  const fommatSLProvince = (arr: IProvince[]) => {
    const newData = arr?.map(item => ({
      id: item.areaId + "-" + item.id,
      title: item.title
    }));
    return newData
  }

  const fommatdataPhoneFilter = (arr: IPhoneFilterListPhoneCustomer[]) => {
    const unique = [...new Set(arr.map(item => item.phone))];
    return unique.map(phone => ({ id: phone, title: phone }));
  }

  const handleSortRequest = (order: 'asc' | 'desc' | null) => {
    let newSort: null | 'asc' | 'desc' = null;
    switch (order) {
      case 'asc':
        newSort = 'desc'
        break;
      case 'desc':
        newSort = null
        break;
      default:
        newSort = "asc"
        break;
    }
    setActiveSort(newSort);
    api.applyColumnState({
      state: [
        {
          colId: columnId,
          sort: newSort || undefined,
        }
      ],
      defaultState: { sort: null },
    });
  };

  const handleFilterClick = useThrottle(() => {
    switch (columnId) {
      // case 'customerType':
      //   setCheckedValues(dataFilterList.listType)
      //   setOpenModalTypeCustomer(true);
      //   setCheckShowSearch(true);
      //   break;

      default: setOpenModal(true);
        break;
    }
  }, 1000)

  const handleSearch = useDebounce((value?: string) => {
    setSearch(value);
  }, 500);

  const handleFilterColumnSelectChange = (columnCode: string, value: (string | number)[]) => {
    switch (columnCode) {
      default:
        break;
    }
  }

  useEffect(() => {
    if (openModal) {
      switch (columnId) {


        default:
          if (!sLUnit.length) {
            // getListUnit();
          }
          if (search !== prevSearchRef.current) {
            // getListUnit();
          }
          // cập nhật prevSearchRef sau khi chạy
          prevSearchRef.current = search;
          break;
          break;
      }
    }
  }, [openModal, search])


  return (
    <>
      <ModalFilter
        isOpen={openModal}
        columnCode={columnId}
        checkShowSearch={checkShowSearch}
        selectedValues={checkedValues}
        sLData={gSLFilterData()}
        handleSearch={handleSearch}
        handleFilterColumnSelectChange={handleFilterColumnSelectChange}
        closeModal={setOpenModal}
      />


      <div className='d-flex align-center gap-1'>
        <span>{displayName}</span>
        <div className='d-flex align-center gap-1'>
          <div className='d-flex flex-column'
            onClick={() => handleSortRequest(activeSort)}
          >
            <CaretUpOutlined
              hidden={activeSort === "desc"}
              className={`cursor-pointer text-10-px `}
            />
            <CaretDownOutlined
              hidden={activeSort === "asc"}
              className={`cursor-pointer text-10-px `}
            />
          </div>
          <div
            hidden={isHiddenFilterIcon}
            onClick={handleFilterClick}
            style={{ marginLeft: 0, cursor: 'pointer' }}
          >
            <FilterIcon isFiltered={isColumnFiltered} />
          </div>
        </div>

      </div>
    </>

  );
};

export default FilterHeader;
